import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    marginTop: theme.spacing(7)
  }
});

export default makeStyles(styles);
